// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Logic$ReactHooksTemplate = require("./Logic.res.js");
var Action$ReactHooksTemplate = require("./Action.res.js");
var Welcome$ReactHooksTemplate = require("./Welcome.res.js");
var MomentRe$ReactHooksTemplate = require("../MomentRe.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var ThankYou$ReactHooksTemplate = require("./ThankYou.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var SurveyTheme$ReactHooksTemplate = require("./surveyTheme.res.js");
var LogicCondition$ReactHooksTemplate = require("./LogicCondition.res.js");
var RedirectionUrl$ReactHooksTemplate = require("./redirectionUrl.res.js");
var TicketCategory$ReactHooksTemplate = require("../tickets/ticketCategory.res.js");
var ApplicationSetting$ReactHooksTemplate = require("../general_settings/applicationSetting.res.js");
var LanguageSelectorPosition$ReactHooksTemplate = require("./LanguageSelectorPosition.res.js");

function empty(param) {
  return {
          id: undefined,
          name: "",
          creator: undefined,
          logo: undefined,
          welcome: undefined,
          deletedWelcome: undefined,
          thankYouList: /* [] */0,
          deletedThankYouList: /* [] */0,
          questions: /* [] */0,
          deletedQuestions: /* [] */0,
          surveyTheme: SurveyTheme$ReactHooksTemplate.empty(),
          updatedAt: undefined,
          logics: /* [] */0,
          redirectionUrl: undefined,
          deletedLogics: /* [] */0,
          enableRedirection: false,
          dataFields: /* [] */0,
          redirectionLogics: /* [] */0,
          redirectionUrls: /* [] */0,
          ticketCategories: /* [] */0,
          redirectionDelay: 500,
          redirectionType: "automatic",
          redirectionButtonText: undefined,
          redirectionDescription: undefined,
          category: "Normal",
          applicationSettings: /* [] */0,
          paginationSettings: {
            TAG: "Uniform",
            _0: 1
          },
          questionsPerPage: undefined,
          pageMappings: undefined,
          languageSelectorPosition: LanguageSelectorPosition$ReactHooksTemplate.default
        };
}

function redirectionDelay(t) {
  return t.redirectionDelay;
}

function redirectionType(t) {
  return t.redirectionType;
}

function redirectionButtonText(t) {
  return t.redirectionButtonText;
}

function redirectionDescription(t) {
  return t.redirectionDescription;
}

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function logo(t) {
  return t.logo;
}

function welcome(t) {
  return t.welcome;
}

function deletedWelcome(t) {
  return t.deletedWelcome;
}

function questions(t) {
  return t.questions;
}

function dataFields(t) {
  return t.dataFields;
}

function deletedQuestions(t) {
  return t.deletedQuestions;
}

function thankYouList(t) {
  return t.thankYouList;
}

function updatedAt(t) {
  return t.updatedAt;
}

function deletedThankYouList(t) {
  return t.deletedThankYouList;
}

function surveyTheme(t) {
  return t.surveyTheme;
}

function logics(t) {
  return t.logics;
}

function redirectionLogics(t) {
  return t.redirectionLogics;
}

function redirectionUrl(t) {
  return t.redirectionUrl;
}

function enableRedirection(t) {
  return t.enableRedirection;
}

function deletedLogics(t) {
  return t.deletedLogics;
}

function redirectionUrls(t) {
  return t.redirectionUrls;
}

function ticketCategories(t) {
  return t.ticketCategories;
}

function category(t) {
  return t.category;
}

function paginationSettings(t) {
  return t.paginationSettings;
}

function questionsPerPage(t) {
  return t.questionsPerPage;
}

function pageMappings(t) {
  return t.pageMappings;
}

function languageSelectorPosition(t) {
  return t.languageSelectorPosition;
}

function setLanguageSelectorPosition(t, languageSelectorPosition) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.languageSelectorPosition = languageSelectorPosition;
  return newrecord;
}

function setName(t, name) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.name = name;
  return newrecord;
}

function setWelcome(t, welcome) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.welcome = welcome;
  return newrecord;
}

function setDeletedWelcome(t, deletedWelcome) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.deletedWelcome = deletedWelcome;
  return newrecord;
}

function setQuestions(t, questions) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.questions = questions;
  return newrecord;
}

function setDeletedQuestions(t, deletedQuestions) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.deletedQuestions = deletedQuestions;
  return newrecord;
}

function setThankYouList(t, thankYouList) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.thankYouList = thankYouList;
  return newrecord;
}

function setDeletedThankYouList(t, deletedThankYouList) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.deletedThankYouList = deletedThankYouList;
  return newrecord;
}

function setLogo(t, logo) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.logo = logo;
  return newrecord;
}

function setSurveyTheme(t, surveyTheme) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.surveyTheme = surveyTheme;
  return newrecord;
}

function setLogics(t, logics) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.logics = logics;
  return newrecord;
}

function setDeletedLogics(t, deletedLogics) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.deletedLogics = deletedLogics;
  return newrecord;
}

function setRedirectionUrl(t, redirectionUrl) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.redirectionUrl = redirectionUrl;
  return newrecord;
}

function setEnableRedirection(t, enableRedirection) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.enableRedirection = enableRedirection;
  return newrecord;
}

function setCategory(t, category) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.category = category;
  return newrecord;
}

function setPaginationSettings(t, paginationSettings) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.paginationSettings = paginationSettings;
  return newrecord;
}

function setQuestionsPerPage(t, questionsPerPage) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.questionsPerPage = questionsPerPage;
  return newrecord;
}

function setPageMappings(t, pageMappings) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.pageMappings = pageMappings;
  return newrecord;
}

function applicationSettings(t) {
  return t.applicationSettings;
}

function setApplicationSettings(t, xs) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.applicationSettings = xs;
  return newrecord;
}

function creatorDecoder(json) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          email: Json_decode.field("email", Json_decode.string, json),
          firstName: Json_decode.field("first_name", Json_decode.string, json),
          lastName: Json_decode.field("last_name", Json_decode.string, json)
        };
}

function decodeThankYouPosition(json) {
  return [
          Json_decode.field("position", Json_decode.$$int, json),
          ThankYou$ReactHooksTemplate.fromJson(json)
        ];
}

function decodeThankyouList(json) {
  return Belt_List.map(Belt_List.sort(Json_decode.field("thank_yous", (function (param) {
                        return Json_decode.list(decodeThankYouPosition, param);
                      }), json), (function (param, param$1) {
                    return param[0] - param$1[0] | 0;
                  })), (function (param) {
                return param[1];
              }));
}

function convertDateToMoment(date) {
  if (date !== undefined) {
    return Caml_option.some(MomentRe$ReactHooksTemplate.moment(undefined, date));
  }
  
}

function decodeDataFields(json) {
  return Json_decode.field("data_fields", (function (param) {
                return Json_decode.list(DataField$ReactHooksTemplate.decode, param);
              }), json);
}

function decodeRedirectionUrls(json) {
  return Json_decode.field("redirection_urls", (function (param) {
                return Json_decode.list(RedirectionUrl$ReactHooksTemplate.decode, param);
              }), json);
}

function decodeTicketCategories(json) {
  return Json_decode.field("ticket_categories", (function (param) {
                return Json_decode.list(TicketCategory$ReactHooksTemplate.fromJson, param);
              }), json);
}

function decodeCategory(json) {
  var match = Json_decode.string(json);
  switch (match) {
    case "normal" :
        return "Normal";
    case "quiz" :
        return "Quiz";
    default:
      return Js_exn.raiseError("Unknown category");
  }
}

function decodePaginationSettings(json) {
  var match = Json_decode.optional((function (param) {
          return Json_decode.field("pagination_settings", Json_decode.string, param);
        }), json);
  if (match === undefined) {
    return {
            TAG: "Uniform",
            _0: 1
          };
  }
  switch (match) {
    case "dynamic" :
        return "Dynamic";
    case "single_page" :
        return "SinglePage";
    case "uniform" :
        var x = Json_decode.optional((function (param) {
                return Json_decode.field("questions_per_page", Json_decode.$$int, param);
              }), json);
        if (x !== undefined) {
          return {
                  TAG: "Uniform",
                  _0: x
                };
        } else {
          return {
                  TAG: "Uniform",
                  _0: 1
                };
        }
    default:
      return ;
  }
}

function decodePageMappings(json) {
  return Json_decode.optional((function (param) {
                return Json_decode.field("page_mappings", (function (param) {
                              return Json_decode.list((function (json) {
                                            return {
                                                    page: Json_decode.field("page", Json_decode.$$int, json),
                                                    fromQuestion: Json_decode.field("from_question", Json_decode.$$int, json),
                                                    toQuestion: Json_decode.field("to_question", Json_decode.$$int, json)
                                                  };
                                          }), param);
                            }), param);
              }), json);
}

function fromJson(json) {
  var questions = Question$ReactHooksTemplate.fromJson(json);
  var thankYous = decodeThankyouList(json);
  var dataFields = decodeDataFields(json);
  var redirectionUrls = decodeRedirectionUrls(json);
  var ticketCategories = decodeTicketCategories(json);
  var welcome = Json_decode.optional((function (param) {
          return Json_decode.field("welcome", Welcome$ReactHooksTemplate.decodeWelcome, param);
        }), json);
  var pos = Json_decode.optional((function (param) {
          return Json_decode.field("language_selector_properties", (function (param) {
                        return Json_decode.field("position", Json_decode.string, param);
                      }), param);
        }), json);
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          creator: Json_decode.field("creator", (function (param) {
                  return Json_decode.optional(creatorDecoder, param);
                }), json),
          logo: Json_decode.field("logo", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          welcome: welcome,
          deletedWelcome: undefined,
          thankYouList: thankYous,
          deletedThankYouList: /* [] */0,
          questions: questions,
          deletedQuestions: /* [] */0,
          surveyTheme: Json_decode.field("survey_theme", SurveyTheme$ReactHooksTemplate.decode, json),
          updatedAt: convertDateToMoment(Json_decode.withDefault(undefined, (function (param) {
                      return Json_decode.field("updated_at", (function (param) {
                                    return Json_decode.optional(Json_decode.string, param);
                                  }), param);
                    }), json)),
          logics: Json_decode.field("logics", (function (param) {
                  return Json_decode.list((function (json) {
                                return Logic$ReactHooksTemplate.decode(questions, welcome, thankYous, dataFields, Json_decode.field("id", (function (param) {
                                                  return Json_decode.optional(Json_decode.$$int, param);
                                                }), json), /* [] */0, /* [] */0, json);
                              }), param);
                }), json),
          redirectionUrl: Json_decode.field("redirection_url", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          deletedLogics: /* [] */0,
          enableRedirection: Json_decode.field("enable_redirection", Json_decode.bool, json),
          dataFields: dataFields,
          redirectionLogics: Json_decode.withDefault(/* [] */0, (function (param) {
                  return Json_decode.field("campaign_logics", (function (param) {
                                return Json_decode.list((function (json) {
                                              return Logic$ReactHooksTemplate.decode(questions, welcome, thankYous, dataFields, Json_decode.field("id", (function (param) {
                                                                return Json_decode.optional(Json_decode.$$int, param);
                                                              }), json), redirectionUrls, ticketCategories, json);
                                            }), param);
                              }), param);
                }), json),
          redirectionUrls: redirectionUrls,
          ticketCategories: ticketCategories,
          redirectionDelay: Json_decode.withDefault(500, (function (param) {
                  return Json_decode.field("redirection_delay", Json_decode.$$int, param);
                }), json),
          redirectionType: Json_decode.withDefault("automatic", (function (param) {
                  return Json_decode.field("redirection_type", Json_decode.string, param);
                }), json),
          redirectionButtonText: Json_decode.optional((function (param) {
                  return Json_decode.field("redirection_button_text", Json_decode.string, param);
                }), json),
          redirectionDescription: Json_decode.optional((function (param) {
                  return Json_decode.field("redirection_description", Json_decode.string, param);
                }), json),
          category: Json_decode.field("category", decodeCategory, json),
          applicationSettings: Json_decode.withDefault(/* [] */0, (function (param) {
                  return Json_decode.field("system_settings", (function (param) {
                                return Json_decode.list(ApplicationSetting$ReactHooksTemplate.decode, param);
                              }), param);
                }), json),
          paginationSettings: decodePaginationSettings(json),
          questionsPerPage: Json_decode.optional((function (param) {
                  return Json_decode.field("questions_per_page", Json_decode.$$int, param);
                }), json),
          pageMappings: decodePageMappings(json),
          languageSelectorPosition: pos !== undefined ? LanguageSelectorPosition$ReactHooksTemplate.fromString(pos) : LanguageSelectorPosition$ReactHooksTemplate.default
        };
}

function toJson(t) {
  var questionAttributes = Belt_List.toArray(Belt_List.concat(Belt_List.mapWithIndex(t.questions, (function (i, x) {
                  return Question$ReactHooksTemplate.toJson(undefined, i + 1 | 0, undefined, x);
                })), Belt_List.mapWithIndex(t.deletedQuestions, (function (i, x) {
                  return Question$ReactHooksTemplate.toJson(undefined, i + 1 | 0, true, x);
                }))));
  var thankyouAttributes = Belt_List.toArray(Belt_List.concat(Belt_List.mapWithIndex(t.thankYouList, (function (i, x) {
                  return ThankYou$ReactHooksTemplate.toJson(undefined, i + 1 | 0, x);
                })), Belt_List.mapWithIndex(t.deletedThankYouList, (function (i, x) {
                  return ThankYou$ReactHooksTemplate.toJson(true, i + 1 | 0, x);
                }))));
  var match = t.deletedWelcome;
  var match$1 = t.welcome;
  var welcomeAttributes;
  if (match$1 !== undefined) {
    welcomeAttributes = Json_encode.nullable((function (x) {
            return Welcome$ReactHooksTemplate.toJson(undefined, x);
          }), match$1);
  } else {
    var partial_arg = true;
    welcomeAttributes = Json_encode.nullable((function (param) {
            return Welcome$ReactHooksTemplate.toJson(partial_arg, param);
          }), match);
  }
  var logicsAttributes = Belt_List.toArray(Belt_List.concat(Belt_List.map(t.logics, (function (x) {
                  return Logic$ReactHooksTemplate.toJson(undefined, x);
                })), Belt_List.map(t.deletedLogics, (function (x) {
                  return Logic$ReactHooksTemplate.toJson(true, x);
                }))));
  var toJsonCategory = function (category) {
    if (category === "Normal") {
      return "normal";
    } else {
      return "quiz";
    }
  };
  var toJsonPaginationSettings = function (x) {
    if (typeof x !== "object") {
      if (x === "SinglePage") {
        return "single_page";
      } else {
        return "dynamic";
      }
    } else {
      return "uniform";
    }
  };
  var encodePageMappings = function (mappings) {
    return Belt_List.toArray(Belt_List.map(mappings, (function (mapping) {
                      return Json_encode.object_({
                                  hd: [
                                    "page",
                                    mapping.page
                                  ],
                                  tl: {
                                    hd: [
                                      "from_question",
                                      mapping.fromQuestion
                                    ],
                                    tl: {
                                      hd: [
                                        "to_question",
                                        mapping.toQuestion
                                      ],
                                      tl: /* [] */0
                                    }
                                  }
                                });
                    })));
  };
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "name",
                  t.name
                ],
                tl: {
                  hd: [
                    "redirection_url",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), t.redirectionUrl)
                  ],
                  tl: {
                    hd: [
                      "enable_redirection",
                      t.enableRedirection
                    ],
                    tl: {
                      hd: [
                        "questions_attributes",
                        questionAttributes
                      ],
                      tl: {
                        hd: [
                          "welcome_attributes",
                          welcomeAttributes
                        ],
                        tl: {
                          hd: [
                            "thank_yous_attributes",
                            thankyouAttributes
                          ],
                          tl: {
                            hd: [
                              "logics_attributes",
                              logicsAttributes
                            ],
                            tl: {
                              hd: [
                                "category",
                                toJsonCategory(t.category)
                              ],
                              tl: {
                                hd: [
                                  "pagination_settings",
                                  Json_encode.nullable(toJsonPaginationSettings, t.paginationSettings)
                                ],
                                tl: {
                                  hd: [
                                    "questions_per_page",
                                    Json_encode.nullable((function (prim) {
                                            return prim;
                                          }), t.questionsPerPage)
                                  ],
                                  tl: {
                                    hd: [
                                      "page_mappings",
                                      Json_encode.nullable(encodePageMappings, t.pageMappings)
                                    ],
                                    tl: {
                                      hd: [
                                        "language_selector_properties",
                                        Json_encode.object_({
                                              hd: [
                                                "position",
                                                LanguageSelectorPosition$ReactHooksTemplate.toString(t.languageSelectorPosition)
                                              ],
                                              tl: /* [] */0
                                            })
                                      ],
                                      tl: {
                                        hd: [
                                          "system_settings_attributes",
                                          Json_encode.list(ApplicationSetting$ReactHooksTemplate.encode, t.applicationSettings)
                                        ],
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

function emptyLogicCondition(survey, trigger) {
  switch (trigger.TAG) {
    case "Question" :
        return LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
                    TAG: "Question",
                    _0: trigger._0
                  });
    case "Welcome" :
    case "Survey" :
        break;
    
  }
  var firstQuestion = List.hd(survey.questions);
  return LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
              TAG: "Question",
              _0: firstQuestion
            });
}

function emptyAction(survey, trigger) {
  var lastQuestion = List.hd(List.rev(survey.questions));
  switch (trigger.TAG) {
    case "Question" :
        var question = trigger._0;
        if (Caml_obj.equal(lastQuestion, question)) {
          var firstThankYou = List.hd(survey.thankYouList);
          return Action$ReactHooksTemplate.emptyAction({
                      TAG: "ThankYou",
                      _0: firstThankYou
                    });
        }
        var index = Belt_Array.getIndexBy(Belt_List.toArray(survey.questions), (function (q) {
                return Caml_obj.equal(q, question);
              }));
        if (index !== undefined) {
          var nextQuestion = Belt_List.getExn(survey.questions, index + 1 | 0);
          return Action$ReactHooksTemplate.emptyAction({
                      TAG: "Question",
                      _0: nextQuestion
                    });
        }
        throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
    case "Welcome" :
    case "Survey" :
        break;
    
  }
  var firstQuestion = List.hd(survey.questions);
  return Action$ReactHooksTemplate.emptyAction({
              TAG: "Question",
              _0: firstQuestion
            });
}

function emptyLogic(t, priority, category, question) {
  return Logic$ReactHooksTemplate.make({
              TAG: "Question",
              _0: question
            }, category, {
              hd: emptyLogicCondition(t, {
                    TAG: "Question",
                    _0: question
                  }),
              tl: /* [] */0
            }, priority, {
              hd: emptyAction(t, {
                    TAG: "Question",
                    _0: question
                  }),
              tl: /* [] */0
            });
}

exports.redirectionDelay = redirectionDelay;
exports.redirectionType = redirectionType;
exports.redirectionButtonText = redirectionButtonText;
exports.redirectionDescription = redirectionDescription;
exports.empty = empty;
exports.id = id;
exports.name = name;
exports.logo = logo;
exports.welcome = welcome;
exports.deletedWelcome = deletedWelcome;
exports.thankYouList = thankYouList;
exports.deletedThankYouList = deletedThankYouList;
exports.questions = questions;
exports.dataFields = dataFields;
exports.updatedAt = updatedAt;
exports.deletedQuestions = deletedQuestions;
exports.surveyTheme = surveyTheme;
exports.logics = logics;
exports.redirectionLogics = redirectionLogics;
exports.redirectionUrl = redirectionUrl;
exports.enableRedirection = enableRedirection;
exports.deletedLogics = deletedLogics;
exports.redirectionUrls = redirectionUrls;
exports.ticketCategories = ticketCategories;
exports.category = category;
exports.paginationSettings = paginationSettings;
exports.questionsPerPage = questionsPerPage;
exports.pageMappings = pageMappings;
exports.languageSelectorPosition = languageSelectorPosition;
exports.setLanguageSelectorPosition = setLanguageSelectorPosition;
exports.setName = setName;
exports.setWelcome = setWelcome;
exports.setDeletedWelcome = setDeletedWelcome;
exports.setQuestions = setQuestions;
exports.setDeletedQuestions = setDeletedQuestions;
exports.setThankYouList = setThankYouList;
exports.setDeletedThankYouList = setDeletedThankYouList;
exports.setLogo = setLogo;
exports.setSurveyTheme = setSurveyTheme;
exports.setLogics = setLogics;
exports.setDeletedLogics = setDeletedLogics;
exports.setRedirectionUrl = setRedirectionUrl;
exports.setEnableRedirection = setEnableRedirection;
exports.setCategory = setCategory;
exports.setPaginationSettings = setPaginationSettings;
exports.setQuestionsPerPage = setQuestionsPerPage;
exports.setPageMappings = setPageMappings;
exports.fromJson = fromJson;
exports.decodeThankyouList = decodeThankyouList;
exports.applicationSettings = applicationSettings;
exports.setApplicationSettings = setApplicationSettings;
exports.toJson = toJson;
exports.emptyLogic = emptyLogic;
/* Logic-ReactHooksTemplate Not a pure module */
